import { render, staticRenderFns } from "./UiSelectOption.vue?vue&type=template&id=396755c6&"
import script from "./UiSelectOption.vue?vue&type=script&lang=js&"
export * from "./UiSelectOption.vue?vue&type=script&lang=js&"
import style0 from "./UiSelectOption.vue?vue&type=style&index=0&id=396755c6&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports